var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cts_box"},[_vm._m(0),_c('h3',{staticClass:"min_ttl"},[_vm._v("マイQRコードをスキャンしてもらってフォローしてもらいましょう。")]),_c('div',{staticClass:"center"},[_c('VueQrcode',{staticStyle:{"border":"4px solid #000"},attrs:{"value":_vm.myTimelineUrl(),"options":{ width: 300, margin: 2 }}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"sub_ttl"},[_c('span',[_vm._v("マイQRコード")])])
}]

export { render, staticRenderFns }